export enum ProfileMenuOptionEventType {
  PROFILE = 'perfil'
}
